module.exports = __webpack_public_path__ + "static/media/sprite.8a5e8e7f.svg";